
import { usePlacesStore } from '@/composables';
import { defineComponent } from 'vue';
// import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
import MapView from '@/components/mapview/MapView.vue'
// import SearchBar from '@/components/searchbar/searchBar.vue'
import MyLocationBtn from '@/components/my-location-btn/my-location-btn.vue'
import TripDetails from '@/components/trip-details/TripDetails.vue';
import  Navbar  from '@/components/navBar/navBar.vue';

export default defineComponent({
  name: 'HomeView',
  components: {
    // HelloWorld,
    // MyLocationBtn,SearchBar, TripDetails, Navbar, MapView
    MyLocationBtn, TripDetails, Navbar, MapView
  },
  setup() {
    usePlacesStore ()
  }
});
